import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_300_6358)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_300_6358",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 25,
			children: /* @__PURE__ */ _jsx("rect", {
				y: .218994,
				width: 24,
				height: 24,
				fill: "currentColor"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_300_6358)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M12 15.6076L7.9308 11.5383L8.8598 10.6288L11.35 13.1191V4.31909H12.65V13.1191L15.1403 10.6288L16.0693 11.5383L12 15.6076ZM6.9008 18.9191C6.4503 18.9191 6.07088 18.7637 5.76255 18.4528C5.45422 18.142 5.30005 17.7615 5.30005 17.3113V15.7998H6.60005V17.3113C6.60005 17.3883 6.63213 17.4588 6.6963 17.5228C6.7603 17.587 6.8308 17.6191 6.9078 17.6191H17.0923C17.1693 17.6191 17.2398 17.587 17.3038 17.5228C17.368 17.4588 17.4001 17.3883 17.4001 17.3113V15.7998H18.7V17.3113C18.7 17.7615 18.5446 18.142 18.2336 18.4528C17.9226 18.7637 17.5418 18.9191 17.0913 18.9191H6.9008Z",
				fill: "currentColor"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_300_6358",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor",
			transform: "translate(0 0.218994)"
		})
	}) })]
});
export default SvgDownload;
